function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "email",
  transform: "translate(0 -61)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_94",
  "data-name": "Group 94",
  transform: "translate(0 61)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1737",
  "data-name": "Path 1737",
  d: "M18.242,61H1.758A1.761,1.761,0,0,0,0,62.758V74.477a1.761,1.761,0,0,0,1.758,1.758H18.242A1.761,1.761,0,0,0,20,74.477V62.758A1.761,1.761,0,0,0,18.242,61ZM18,62.172l-7.962,7.962L2.006,62.172ZM1.172,74.234V62.995l5.644,5.6ZM2,75.063l5.647-5.647,1.979,1.962a.586.586,0,0,0,.827,0l1.929-1.929L18,75.063Zm16.828-.829-5.617-5.617L18.828,63Z",
  transform: "translate(0 -61)",
  fill: "#fff"
})));

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15.234,
    viewBox: "0 0 20 15.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1c767aff.svg";
export { ForwardRef as ReactComponent };